// E-Ticaret › Ürünler › Ürün Görüntüleme Ayarları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.productDisplay';

export const ecommerceProductDisplayGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Ürün görüntüleme nasıl ayarlanır?'),
  intro: t(`${G}.intro`, 'Bu ekranda sitenizin kategori ve ürün listesi sayfalarında ürünlerin nasıl görüneceğini ayarlarsınız: kart şablonu, satırdaki ürün sayısı, kartta gösterilecek bilgiler, stok uyarıları ve sol filtre paneli. Değişiklikler otomatik kaydedilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ürün Kart Motoru'),
    form: t(`${G}.regions.form`, 'Kart, filtreleme ve stok ayarları'),
    list: t(`${G}.regions.list`, 'Kategori Sol Filtre Ayarları'),
    footer: t(`${G}.regions.footer`, 'Ürün Kart Tasarımı'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Kart şablonunu seçin'),
      text: t(`${G}.s1.text`, '"Ürün Kart Motoru" bölümünde kategori sayfasında ürünlerin nasıl listeleneceğini seçin; önizlemeye tıklayınca şablon aktif olur. Legacy (Mevcut) klasik ızgara düzenidir; Sabit Kart V2 sabit boyutlu modern kartlar ve fiyat çerçevesi sunar; B2B Optimize sol filtre paneli, tablo/liste/kart görünümü, toplu sepete ekleme ve Excel aktarımı sunar; Şablon 3 kompakt kartlar ve ürün detayını popup olarak açar.'),
      tips: [
        t(`${G}.s1.tip1`, 'B2B Optimize seçilince standart sol filtre kapatılır; bu şablon kendi filtre panelini (Özel Filtreler, Kategoriler, Markalar) kullanır.'),
        t(`${G}.s1.tip2`, '"Satırdaki ürün sayısı (masaüstü)" bir satırdaki kart sayısını belirler; mobilde 1 veya 2 sütuna düşer. "Sitede kolon seçiciyi göster" açıksa müşteri sağ üstten 2–6 kolon arasında değiştirebilir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Kart Ayarları ve mobil düzen'),
      text: t(`${G}.s2.text`, '"Kart Ayarları" bölümünde kartta Ürün Adı, SKU, Fiyat, kişi başı fiyat ibaresi, Stok Durumu ve Sepete Ekle düğmesinin görünüp görünmeyeceğini seçin. "Fiyatı Göster" kapatılırsa kartta fiyat gizlenir ve İncele düğmesi görünür. "Mobil Kart Düzeni" ile mobilde satır başına bir veya iki ürün gösterin.'),
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Filtreleme ve stok uyarısı'),
      text: t(`${G}.s3.text`, '"Filtreleme ve Görünüm" bölümünde "Tükenenleri gizle" açıkken stoğu biten ürünler mağazada varsayılan olarak gizlenir; "Resmi Olmayan Ürünleri Gizle" görseli olmayan ürünleri gizler; "Breadcrumb Navigasyonunu Göster" sayfalarda "Ana Sayfa > Kategori > Alt Kategori" yolunu gösterir.'),
      tips: [
        t(`${G}.s3.tip1`, '"Müşteriye stok uyarısı ver" açıkken sepete eklemede ve sepette "yalnızca X adet kaldı" uyarısı çıkar; kapalıyken müşteri kalan stoğu görmez. Eksi stoğa düşebilen ürünlerde bu uyarı çıkmaz.'),
        t(`${G}.s3.tip2`, '"Tükenmek üzere eşiği": stok bu adedin altına düşünce (ve stok 0\'dan büyükken) ürün görselinde "Tükenmek üzere" yazısı görünür. 0 kapalı demektir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Filtre modunu seçin'),
      text: t(`${G}.s4.text`, '"Kategori Sol Filtre Ayarları"nda "Filtre Modu"nu seçin: Kapalı, Standart, Gelişmiş veya Üst Çubuk. Sol panelde gösterilecek blokları (Alt Kategoriler, Kategori, Marka, Fiyat Aralığı, Ürün Özellikleri, seçenek adetleri, Filtreleri Temizle düğmesi, «Tükenenleri gizle» filtresi) anahtarlarla açıp kapatın.'),
      tips: [
        t(`${G}.s4.tip1`, 'Üst Çubuk modunda sol panel gösterilmez. Filtreler ve sıralama, kategorinin üstünde sabit (yapışkan) bir çubukta açılır menüler olarak sunulur.'),
        t(`${G}.s4.tip2`, 'Üst Çubuk modunda «Marka / Fiyat / Kategori» ve «Tükenenleri gizle» ayarları çubuğa hangi filtrelerin ekleneceğini belirler; alt kategori paneli ve sol hizalama seçenekleri bu modda etkisizdir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Özel filtreler'),
      text: t(`${G}.s5.text`, '"Özel Filtreler" ile kendi filtre başlığınızı oluşturun ve seçeneklerini tanımlayın. Her seçeneğe bir Etiket ve virgülle ayrılmış anahtar kelimeler yazın; ürün adı ve / veya açıklamasında bu kelimeler geçen ürünler o seçenekle eşleşir ("Eşleşme: Ad / Açıklama"). Filtreyi "Aktif" anahtarıyla açıp kapatın.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Ürün kart tasarımı'),
      text: t(`${G}.s6.text`, '"Ürün Kart Tasarımı" bölümünde mağazadaki ürün kartının önizlemesini görür ve düzenlersiniz. Örnek kartta sağ tıklayıp "Düzenle" ile ilgili bölümü yapılandırın. Mobilde kart genişliği doğrudan ayarlanamaz; bunun için "Mobil Kart Düzeni"ni kullanın.'),
      tips: [
        t(`${G}.s6.tip1`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
